"use client"

import type { ComponentProps } from "react"
import {
  StatusCell as PackageStatusCell,
  type StatusCellOption,
} from "@exxatdesignux/ui/components/data-views/table-cells"

export type { StatusCellOption }

/** Icon status cells use `md`. Label-only cells stay `sm`. */
export function StatusCell(
  props: ComponentProps<typeof PackageStatusCell>,
) {
  const size = props.size ?? (props.icon ? "md" : "sm")
  return <PackageStatusCell {...props} size={size} />
}
